export const BREAK_URLS_STYLE = { wordWrap: 'break-word' };
export const BLOCKS_IN_ROW = 4;
